import { useDealersQuery } from '@/features/dealers/hooks/useDealersQuery';

export function useHasInScopeDealers(enabled: boolean) {
  const query = useDealersQuery({ per_page: 1 }, { enabled });
  const confirmedNone = query.isSuccess && (query.data?.meta.total ?? 0) === 0;
  return {
    isLoading: enabled && query.isLoading,
    hasDealers: !enabled || !confirmedNone,
  };
}
